(function () {
  function PrinterDialog() {
    var printerChoices = new window.PrinterChoices();

    // configuration
    var printDialogTitle = "Choose Your Print Style";
    var advancedDescription =
      "Print map with data presented in an advanced grid.";
    var simpleDescription = "Print map with simplified view of data as a list";
    var cancelDescription = "Abort printing and resume working on the map.";

    //cached DOM element
    var $dialog;

    function choicesByCategory(category) {
      return function (choice) {
        return choice.category == category;
      };
    }

    function printDialogHtml(availablePrinterChoices) {
      var advancedChoices = availablePrinterChoices
        .filter(choicesByCategory("advanced"))
        .map(printerChoices.choiceToHtml)
        .join("");

      var simpleChoices = availablePrinterChoices
        .filter(choicesByCategory("simple"))
        .map(printerChoices.choiceToHtml)
        .join("");

      return (
        '<div class="printer-dialog-overlay"></div><div class="printer-dialog" >' +
        '<div class="printer-dialog-head">' +
        '<label class="printer-dialog-title">' +
        printDialogTitle +
        "</label>" +
        (BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.routeCalculated
          ? '<label class="printer-dialog-notice">Route printing limits table data to selected rows and includes a written list of directions at bottom of the printed pages.</label>'
          : "") +
        "</div>" +
        '<div class="printer-dialog-body">' +
        '<div class="printer-dialog-category printer-dialog-category-advanced">' +
        '<label class="printer-dialog-subtitle">Advanced Map</label>' +
        '<div class="printer-dialog-category-description">' +
        "<p>" +
        advancedDescription +
        "</p>" +
        "</div>" +
        '<ul class="printer-dialog-choices">' +
        advancedChoices +
        "</ul>" +
        "</div>" +
        '<div class="printer-dialog-category printer-dialog-category-simple">' +
        '<label class="printer-dialog-subtitle">Simple Map</label>' +
        '<div class="printer-dialog-category-description">' +
        "<p>" +
        simpleDescription +
        "</p>" +
        "</div>" +
        '<ul class="printer-dialog-choices">' +
        simpleChoices +
        "</ul>" +
        "</div>" +
        "</div>" +
        '<button class="printer-dialog-cancel printer-cancel" data-description="' +
        cancelDescription +
        '">' +
        "Cancel" +
        "</button>" +
        "</>"
      );
    }

    function destroy() {
      if ($dialog) {
        $dialog.remove();
        $dialog = null;
      }
    }

    function printMapChoice(clickEvent) {
      var id = $(clickEvent.currentTarget).data("id");
      var printChoice = printerChoices.getPrinterChoice(id);
      destroy();
      return window.batchGeoPrinter.printViewOn(printChoice);
    }

    function cancelPrint() {
      destroy();
    }

    /**
     * open - This opens the advanced print dialog
     *
     * @returns {jQuery}  This function retuns a reference to the opened element
     */
    function open() {
      if (
        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.routeCalculated
      ) {
        printerChoices.setMode("route");
      } else {
        printerChoices.setMode(); // default in case it's been toggled previously
      }

      if (!$dialog) {
        $dialog = $(printDialogHtml(printerChoices.getPrinterChoices()));

        $dialog.find(".printer-dialog-cancel").eq(0).on("click", cancelPrint);

        $dialog
          .find(".printer-dialog-choice-frame")
          .on("click", printMapChoice);

        $("body").append($dialog);
      }

      return $dialog;
    }

    return {
      open,
    };
  }

  window.PrinterDialog = PrinterDialog;
})();
